








import { Component, Watch } from 'vue-property-decorator';
import Vue from 'vue'
import { mixins } from 'vue-class-component';

@Component
export default class MainMenuMobile extends Vue {
  open() {
    this.$store.commit('mobileMenuOpen', true);
  }
}
